import { render, staticRenderFns } from "./PersonPerformanceLineDetail.vue?vue&type=template&id=b1781456&scoped=true&"
import script from "./PersonPerformanceLineDetail.vue?vue&type=script&lang=js&"
export * from "./PersonPerformanceLineDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1781456",
  null
  
)

export default component.exports